import { RoundFn } from '@common/utils/sales-channel-pricing.util';

/**
 * Contratos entre la sección de Precios de venta (dueña de la lógica) y sus vistas: la tabla de desktop y las
 * tarjetas de mobile. Son objetos nuevos en cada cambio para que las vistas `OnPush` se repinten solo entonces.
 */

/** Lo que cada fila o tarjeta necesita saber para pintarse, sin suscribirse a nada. */
export interface PriceGridContext {
    canEdit: boolean;
    canViewUnitPrice: boolean;
    isMarkupCommerce: boolean;
    /** Selección masiva por canal en curso: bloquea los checkbox. */
    applyingBulk: boolean;
    /**
     * Guardado en curso: bloquea campos y checkbox. Lo que se editara con el POST en vuelo no viaja en él y, al terminar,
     * pasaría por guardado sin haberse enviado.
     */
    saving?: boolean;
    /** Sube cuando la sección cambia filas que la vista no originó (masivo, descarte, error al guardar). */
    revision: number;
    round: RoundFn;
}

export type PriceListEmptyKind = 'tab' | 'search' | null;

/** Estado de la lista cargada de la pestaña. */
export interface PriceListView {
    /** Sube con cada recarga desde el inicio: la vista vuelve arriba. */
    generation: number;
    /** Recarga desde el inicio en curso (las filas se ocultan). */
    loading: boolean;
    /** La recarga falló y no hay lista de esta pestaña que mostrar. */
    failed: boolean;
    loadingMore: boolean;
    loadMoreFailed: boolean;
    hasMore: boolean;
    loaded: number;
    totalDocs: number;
    appliedSearch: string;
    emptyKind: PriceListEmptyKind;
    /** Nombre de la pestaña para los textos («Sin productos en Inventario»). */
    sectionLabel: string;
}

export interface ChannelToggleEvent {
    scId: string;
    value: boolean;
    /** El checkbox nativo del encabezado, para devolverlo a su estado si el masivo no se aplica. */
    target?: HTMLInputElement;
}

export interface ProductToggleEvent {
    productId: string;
    value: boolean;
}

export interface CellToggleEvent {
    productId: string;
    scId: string;
    value: boolean;
}

export interface PriceCommitEvent {
    product: any;
    scId: string;
}

export interface MarginCommitEvent {
    product: any;
    scId: string;
    value: string;
}

export const SECTION_LABELS: Record<string, string> = {
    inventory: 'Inventario',
    template: 'Receta/Combo',
    service: 'Servicios',
};
